import React from 'react';
import autoBind from 'react-autobind';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Row, Col } from 'react-bootstrap';
import DDadosItem from '@common/components/ddados/ddados.item';
import DDados from './grid.consultaSQL.ddados';
import Form from '@common/components/validation/form.validation';
import clipboardHelper from '@common/helpers/clipboard.helper';
//Context
import { withGridContext } from './grid.factory';

class GridConsultaSQL extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClose() {
    const { context } = this.props;
    context.setState({ showConsultarSQL: false }, false);
  }

  render() {
    const { context } = this.props;
    const { querySQL } = context;

    const { Campos } = DDados;

    return (
      <Form>
        <SmartModal show={context.showConsultarSQL} onHide={this.onClose} keyboard size="lg" backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <h3>Consultar SQL</h3>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col lg={11} />

              <Col>
                <a className="btn btn-primary" onClick={() => clipboardHelper.copyToClipboard(querySQL)} title="Copiar">
                  <i className={`pointer-events-none fas fa-copy`} style={{ color: 'white' }} />
                </a>
              </Col>
            </Row>

            <Row>
              <Col style={{ marginTop: '27px' }}>
                <DDadosItem
                  name="QuerySQL"
                  {...Campos.QuerySQL}
                  state={{ QuerySQL: querySQL }}
                  Tamanho={querySQL?.length ?? 0}
                />
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <button onClick={this.onClose} className="btn btn-cancel">
              <i className="fa fa-times" /> Fechar
            </button>
          </Modal.Footer>
        </SmartModal>
      </Form>
    );
  }
}

export default withGridContext(GridConsultaSQL);
